import { IFormValidation, SelectFormField } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { DayOfWeekValue } from 'types/enum/DayOfWeek';

interface IDayOfWeekFormFieldProps {
  name: string;
  form: any;
  disabled?: boolean;
  hasArrow?: boolean;
  onBlur?: () => void;
  onClick?: () => void;
  onFocus?: () => void;
  onKeyDown?: () => void;
  onChange?: (value: DayOfWeekValue) => void;
  placeholder?: string;
  validations?: Array<IFormValidation<DayOfWeekValue>>;
  className?: ClassName;
}

const DayOfWeekFormField: FunctionComponent<IDayOfWeekFormFieldProps> = (props) => {
  const { className, ...fieldProps } = props;

  const [t] = useTranslation();

  const classes = classNames('day-of-week-form-field', className);

  return (
    <SelectFormField
      className={classes}
      {...fieldProps}
      options={Object.values(DayOfWeekValue).map((value) => ({ value, label: t(value) }))}
    />
  );
};

export default DayOfWeekFormField;
